import { LoadSkia } from '@shopify/react-native-skia/lib/module/web';
import { lazy, Suspense, useEffect, useMemo, useState } from 'react';

let loadedSkia = false;

function useSkiaLoaded() {
    const [isLoaded, setLoaded] = useState(loadedSkia);
    useEffect(() => {
        // You only load once
        if (loadedSkia) {
            return;
        }

        let isMounted = true;
        LoadSkia().then(() => {
            if (isMounted) {
                loadedSkia = true;
                setLoaded(() => true);
            }
        })
        return () => {
            isMounted = false;
        }
    }, []);
    return isLoaded;
}

export function AsyncSkia({ getComponent, fallback }) {
    // const loaded = useSkiaLoaded();

    // if (loaded) {
    //     return null;
    // }
    const Inner = useMemo(() => lazy(async () => {
      await LoadSkia();
      return getComponent()
    }), [getComponent]);

  return (
    <Suspense fallback={fallback}><Inner/></Suspense>
  );
}
